import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ConfiguraRltPageComponent } from './configuracion-rlt/configura-rlt-page/configura-rlt-page.component';
import { ConfiguracionPageComponent } from './configuracion-page/configuracion-page.component';
import { SqpComponentsModule } from 'src/app/shared/components/sqp-components/sqp-components.module';
import { ParametrosRltComponent } from './configuracion-rlt/parametros-rlt/parametros-rlt.component';

@NgModule({
  declarations: [
    ConfiguraRltPageComponent,
    ConfiguracionPageComponent,
    ParametrosRltComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    AgGridModule,
    ReactiveFormsModule,
    MatDialogModule,
    DragDropModule,
    SqpComponentsModule
  ],

  providers: [
    {
      provide: MatDialogRef,
      useValue: {}
    }
 ],
})
export class ConfiguracionModule { }
